import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';

export const redirectLoggedInGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.dbUser$.pipe(
    map((user) => {
      if (user) {
        void router.navigate(['/admin']);
        return false;
      }
      return true;
    }),
  );
};
